import { HardDrives } from '@phosphor-icons/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { Button } from 'theSource/components';
import { selectIsAuthenticated } from 'theSource/features';
import {
  useConfigurationQuery,
  useContentSettingsQuery,
} from 'theSource/queries';

export type AdminHomePageButtonProps = {
  dataTestId?: string;
};

export const AdminHomePageButton = ({
  dataTestId,
}: AdminHomePageButtonProps) => {
  const { t } = useTranslation('pages.more');
  const { configuration } = useConfigurationQuery();
  const [loading, setLoading] = useState(false);
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const { contentSettings } = useContentSettingsQuery({
    enabled: Boolean(isAuthenticated && configuration?.apiHost),
  });

  const navigateToAdminHomepage = () => {
    setLoading(true);
    const subscriberAdminUrl = contentSettings?.subscriber_admin_url;
    if (subscriberAdminUrl) {
      window.location.href = subscriberAdminUrl;
    }
  };

  return (
    <Button
      data-testid={dataTestId || null}
      endIcon={<HardDrives size={16} weight="bold" />}
      label={t('adminHomePage')}
      variant="tertiary"
      type="button"
      onClick={navigateToAdminHomepage}
      isLoading={loading}
      fullWidth
    />
  );
};
